import SiteLayout from '~/components/layout/SiteLayout'
import UserHeader from '~/components/users/UserHeader'

export default props => {

  const pageHeader = (
    <div className='container'>
      <UserHeader
        user={props.user}
        profile={props.profile}
        currentUser={props.currentUser}
        onClickCharge={props.onClickCharge}
      />
    </div>
  )

  return (
    <SiteLayout {...props} pageHeader={pageHeader}>
      {props.children}
    </SiteLayout>
  )
}
